import React from 'react';
import { Box, Typography, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const DateQuestion = ({ 
  question, 
  value = null, 
  onChange, 
  interpolateText, 
  answers, 
  error 
}) => {
  const handleDateChange = (newValue) => {
    onChange(newValue);
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{ mb: 3, fontWeight: 600 }}>
        {interpolateText(question.text, answers)}
      </Typography>
      
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          value={value}
          onChange={handleDateChange}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              error={!!error}
              helperText={error}
              autoFocus
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: '1.1rem'
                }
              }}
            />
          )}
          minDate={new Date()} // Prevent past dates
          inputFormat="MM/dd/yyyy"
          label="Select date"
        />
      </LocalizationProvider>
      
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        Please select a date that works best for you. We'll do our best to accommodate your preferred timing.
      </Typography>
    </Box>
  );
};

export default DateQuestion;